import { Box, Typography } from "@outschool/backpack";
import {
  ActivityEnrollableTimesModal_ActivityFragment,
  ClassDetailsQuery_ActivityFragment,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { ChooseATimeOrClassScheduleRequestButtonProps } from "./types";

export default function ChooseAnotherTime({
  activity,
  ChooseATimeOrClassScheduleRequestButton,
  leader,
  showDescription = true,
}: {
  activity:
    | ActivityEnrollableTimesModal_ActivityFragment
    | ClassDetailsQuery_ActivityFragment;
  ChooseATimeOrClassScheduleRequestButton: (
    props: ChooseATimeOrClassScheduleRequestButtonProps
  ) => JSX.Element;
  leader: Pick<
    ClassDetailsQuery_ActivityFragment["leader"],
    "hasAvailabilitySet"
  >;
  showDescription?: boolean;
}) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\ChooseAnotherTime"
  );
  return (
    <Box
      flex
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: showDescription ? "flex-start" : "center",
        paddingY: "1em",
        textAlign: "center",
      }}
    >
      {showDescription && (
        <Typography sx={{ marginRight: "1em" }}>
          {t("Don’t see what you’re looking for?")}
        </Typography>
      )}
      <ChooseATimeOrClassScheduleRequestButton
        activity={activity}
        leader={leader}
        /* eslint-disable-next-line i18next/no-literal-string */
        locationRenderedOn="AvailableTimesTable"
        sx={{ color: "black" }}
      />
    </Box>
  );
}
